<template>
  <data-table
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="total"
      :loading="loading"
      class="row-pointer"
      @click:row="onRowClicked"
  >
  </data-table>
</template>

<script>
import api from "@/services/api";
import DataTable from "@/components/data-table/DataTable";
import {getDatatableParams, setDatatableOptions} from "@/utils/helpers";

export default {
  props: {
    id: {
      type: [Number, String],
      required: true,
    }
  },
  components: {
    DataTable,
  },
  data() {
    return {
      loading: false,
      items: [],
      total: 0,
      options: {},
      headers: [
        {text: 'Kategoria', value: 'categoryName', sortable: false},
        {text: 'Ilość', value: 'quantity', sortable: false},
        {text: 'Kod pocztowy', value: 'postalCode', sortable: false},
        {text: 'Miasto', value: 'city', sortable: false},
      ],
    };
  },
  created() {
    getDatatableParams.call(this);
    this.getSaleOffers();
  },
  watch: {
    options: {
      handler() {
        this.getSaleOffers();
        setDatatableOptions.call(this);
      },
      deep: true,
    },
  },
  methods: {
    getSaleOffers() {
      if (this.loading) {
        return;
      }

      this.loading = true;

      const {page, itemsPerPage} = this.options;
      const params = {
        companyId: this.id,
        type: 'own',
        withCompany: false,
        withUser: false,
        offset: page > 1 ? itemsPerPage * (page - 1) : 0,
      };

      if (-1 !== itemsPerPage) {
        params.limit = itemsPerPage;
      }

      api.get(`/api/sale-offers`, {params})
          .then((response) => {
            this.items = response.data.items;
            this.total = response.data.total;
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się wczytać ofert sprzedaży.',
              error,
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onRowClicked(saleOffer) {
      this.$router
          .push({name: 'sale-offer-details', params: { id: saleOffer.id }})
          .catch(() => {});
    },
  },
}
</script>